<template>
  <v-layout justify-center>

    <v-dialog v-model="dialog_status" class="dialog-container"
      scrollable persistent max-width="500px"
      @keydown.esc="close()">

      <template>
        <v-card v-if="!compare_opened" height=600>

          <!-- Process: title -->
          <v-card-title class="card-title" :class="{'card-title-ref':mode=='refs'}"
            v-if="!done&&!doc_preview.compare">
            <div class="card-title-content">
              <div class="card-title-left">

                <div v-if="mode=='docs'">
                  <v-clamp autoresize :max-lines="1">{{ project_info.title }}</v-clamp>
                  <div>도큐먼트 추가하기</div>
                </div>
                <div v-else-if="mode=='refs'">
                  <v-clamp autoresize :max-lines="1">{{ title }}</v-clamp>
                  <div>참고문헌 추가하기</div>
                </div>
                <div v-else>도큐먼트 추가하기</div>

              </div>

              <div>
                <v-tooltip bottom v-if="option==2">
                  <template v-slot:activator="{ on }">
                    <v-btn outlined icon x-small v-on="on"
                      @click="changeDocType(doc_type);gaClick('addDocuments_btn_reload')">
                      <v-icon x-small>mdi-reload</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('add_documents.reload') }}</span>
                </v-tooltip>
                <v-btn icon
                  @click="close();gaClick('addDocuments_btn_close')">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>

            <v-tabs grow v-model="option" color="#536bff"
              background-color="transparent">
              <v-tab v-for="(opt, i) in options" :key="i">
                {{ $t('add_documents.' + opt) }}
              </v-tab>
            </v-tabs>

          </v-card-title>

          <!-- Process: contents -->
          <v-card-text class="py-5" v-if="!done&&!doc_preview.compare">
            
            <!-- Option 0: Search -->
            <div v-if="option==0">
              <v-form class="buttons" @submit.prevent="search">
                <v-text-field class="text-field" flat v-model="query_title" 
                  ref="title"
                  outlined clearable color="#536bff"
                  placeholder="제목">
                </v-text-field>
                <v-text-field class="text-field"  flat v-model="query_authors" outlined clearable
                  color="#536bff"
                  placeholder="저자(쉼표로 구분)">
                </v-text-field>
                <v-btn class="btn-magnify" icon color="#536bff" type="submit">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-form>
              <div v-if="busy" id="loading">
                <v-progress-circular
                  indeterminate
                  color="#536bff"
                ></v-progress-circular>
              </div>
              <div v-else-if="error_search" class="empty-wrap">
                <div class="empty-contents-title">검색결과가 너무 많습니다 😅</div>
                <div class="empty-contents-meta">다른 키워드를 사용해보시겠어요?</div>
              </div>
              <div v-else-if="!!searching">
                <div class="search-results-header">
                  <div>검색결과 {{ search_results.length }} 건</div>
                  <div>
                    <v-icon small color="rgba(0, 0, 0, 0.26)">mdi-checkbox-blank</v-icon>
                    <span>이미 추가된 도큐먼트</span>
                  </div>
                </div>
                <div class="search-results-list" v-if="!!search_results.length">
                  <div class="doc-card" v-for="(doc, index) in search_results"
                    :key="index">
                    <div class="doc-card-content">

                      <div class="card-header">
                        <v-btn small icon @click="checkDoc(doc.key)" :disabled="doc.in">
                          <v-icon color="primary" v-if="doc.in">mdi-checkbox-blank</v-icon>
                          <v-icon color="#c1c3c9" v-else-if="!checked_docs.includes(doc.key)">mdi-checkbox-blank-outline</v-icon>
                          <v-icon color="#c1c3c9" v-else>mdi-checkbox-marked</v-icon>
                        </v-btn>
                        <div class="header-title">
                          <div class="doctype-dot-wrap">
                            <div :style="setColor(doc.doc_type)" class="doctype-dot"></div>
                          </div>
                          <div>
                            <v-clamp :max-lines="1">{{ doc.title }}</v-clamp>
                          </div>
                        </div>
                      </div>
                      <div class="card-meta">{{ doc.authors_iso690 }}({{ doc.date }})</div>
                      <div class="card-detail">
                        <span v-if="!!doc.publication">{{ doc.publication }}</span>
                        <span v-if="!!doc.number">{{ doc.number }}</span>
                        <span v-if="!!doc.publisher">
                          <span v-if="!!doc.publication||!!doc.number"> - </span>
                          <span>{{ doc.publisher }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="empty-wrap">
                  <div class="empty-contents-title">찾으시는 결과가 없네요 😅</div>
                  <div class="empty-contents-meta">학술DB에서 서지사항을 가져오거나, 직접 정보를 입력할 수 있습니다.</div>
                  <div>
                    <div>
                      <v-icon>mdi-numeric-1-box</v-icon>
                      학술DB에서 검색 후 파일 업로드
                      <!-- URL: Google scholar -->
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn icon x-small color="#536bff" v-on="on"
                            :href="getURL('g')" target="_blank">
                            <v-icon small>mdi-google</v-icon>
                          </v-btn>
                        </template>
                        <span>Google Scholar에서 검색하기</span>
                      </v-tooltip>
                      <!-- URL: Semantic Scholar-->
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn icon x-small color="#536bff" v-on="on"
                            :href="getURL('s')" target="_blank">
                            <v-icon small>mdi-check-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Semantic Scholar에서 검색하기</span>
                      </v-tooltip>
                      <!-- URL: Google scholar -->
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn icon x-small color="#536bff" v-on="on"
                            :href="getURL('m')" target="_blank">
                            <v-icon small>mdi-microsoft</v-icon>
                          </v-btn>
                        </template>
                        <span>Microsoft Academic에서 검색하기</span>
                      </v-tooltip>
                    </div>
                    <div>
                      <v-icon>mdi-numeric-2-box</v-icon>
                      ENW, RIS, BIB 파일 업로드 혹은 붙여넣기
                      <v-btn x-small dark depressed @click="option=1" color="#536bff">파일 업로드</v-btn>
                    </div>
                    <div>
                      <v-icon>mdi-numeric-3-box</v-icon>
                      직접 입력하기
                      <v-btn x-small dark depressed @click="option=2" color="#536bff">직접 입력하기</v-btn>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else id="exp-wrapper">
                <div id="exp-title" v-if="mode=='docs'">프로젝트에 도큐먼트 추가하는 방법</div>
                <div id="exp-title" v-if="mode=='clip'">클립에 도큐먼트 추가하는 방법</div>
                <div id="exp-title" v-if="mode=='refs'">참고문헌 추가하는 방법</div>
                <div id="exp-contents">
                  <div class="exp-content"><v-icon>mdi-numeric-1-box</v-icon>
                    BT에서 검색하기 (☝️위에서 키워드 작성 후 엔터!)</div>
                  <div class="exp-content"><v-icon>mdi-numeric-2-box</v-icon>
                    ENW, RIS, BIB 파일 업로드 혹은 붙여넣기
                    <v-btn x-small dark depressed @click="option=1" color="#536bff">파일 업로드</v-btn>
                  </div>
                  <div class="exp-content"><v-icon>mdi-numeric-3-box</v-icon>
                    직접 입력하기 
                    <v-btn x-small dark depressed @click="option=2" color="#536bff">직접 입력하기</v-btn>
                  </div>
                </div>
                <div id="exp-meta">BT는 모든 사용자가 <b class="explanation">도큐먼트의 서지사항을 공유</b>하는 플랫폼입니다.</div>
                <div>개인적인 메모는 공유되지 않는 <b class="explanation">내 리뷰</b>를 활용해주세요!</div>
              </div>
            </div>
            
            <!-- Option 1: Upload files -->
            <div v-if="option==1">
              <div class="meta-title">파일 업로드</div>
              <div class="meta-text">
                EndNote(.ris, .enw), BibTex(.bib) 포맷의 파일을 업로드해주세요.<br>
                여러 개의 파일을 한 번에 업로드할 수 있습니다(총 2MB 이하).<br>
              </div>
              <v-btn dark block color="#536bff"
                @click="initiate()">
                <v-icon>publish</v-icon>
                <span>{{ $t('add_documents.upload') }}</span>
                <input type="file"
                  ref="file"
                  accept=".enw, .ris, .bib, .bibtex, .txt, .ENW, .RIS, .BIB, .BIBTEX, .TXT"
                  multiple="multiple"
                  @change="uploadFieldChange">
              </v-btn>
              <div class="divider">
                <v-divider></v-divider>
                <span>or</span>
                <v-divider></v-divider>
              </div>
              <!-- TODO: drag & drop -->
              <div class="meta-title">복사&붙여넣기</div>
              <div class="meta-text">
                EndNote(.ris, .enw), BibTex(.bib) 형식의 텍스트를 복사&붙여넣기 후 아래 '추가하기' 버튼을 눌러주세요.<br>
                ※ 동일한 형식의 도큐먼트 여러 개를 한 번에 추가할 수 있습니다.<br>
                ※ 단, enw 형식의 텍스트일 경우 각 도큐먼트를 빈 행으로 구분해주세요.<br>
              </div>
              <v-textarea outlined rows="3" v-model="text"></v-textarea>
              <v-btn depressed block
                @click="pasteText()"
                :disabled="!text.length"
                color="#536bff" class="white--text">{{ $t('add_documents.add')}}
              </v-btn>
            </div>

            <!-- Option 2: Input manually -->
            <v-form :key="form_key" v-if="option==2">

              <div class="input-field">
                <div class="input-label">
                  <span>{{ $t('add_documents.type') }}</span>
                  <span class="required">*</span>
                </div>
                <v-select dense
                  :items="doc_type_list"
                  v-model="doc_type"
                  @change="changeDocType(doc_type)"
                  item-value="key"
                  item-text="name"
                  label="Document Type">
                  <template v-slot:label>
                    {{ $t('doc_info.doc_type') }}
                  </template>
                </v-select>
              </div>

              <div v-for="(key, index) in keys" :key="index"
                v-if="main_keys.includes(key)">
                <manual-input-form
                  :keyname="key"
                  :data.sync="document[key]"
                  :isrequired="required_keys.includes(key)"
                  :complete.sync="document[getComplete(key)]"
                  :query="query"
                  :document.sync="sug_document">
                </manual-input-form>
              </div>

              <div v-for="(key, index) in keys" :key="index"
                v-if="is_expanded&&!main_keys.includes(key)">
                <manual-input-form
                  :keyname="key"
                  :data.sync="document[key]"
                  :isrequired="required_keys.includes(key)"
                  :complete.sync="document[getComplete(key)]"
                  :query="query"
                  :document.sync="sug_document">
                </manual-input-form>
              </div>

              <div class="expand">
                <div v-if="!is_expanded"
                  @click="is_expanded=true">
                  {{ $t('add_documents.more')}}
                  <v-icon>expand_more</v-icon>
                </div>
                <div v-else
                  @click="is_expanded=false">
                  {{ $t('add_documents.less')}}
                  <v-icon>expand_less</v-icon>
                </div>
              </div>

            </v-form>
          </v-card-text>

          <v-card-actions class="actions" v-if="!done&&!doc_preview.compare">
            <div v-if="error">
              <div class="message-error">
                {{ error_message }}
              </div>
            </div>
            <div v-if="option==2">
              <div class="explanation">
                추가한 도큐먼트 정보는 BT의 모든 사용자가 검색할 수 있습니다
              </div>
            </div>
            <div class="buttons" v-if="option==0&&!!checked_docs.length">
              <v-btn v-if="mode=='docs'"
                depressed block dark color="#536bff" @click="addDocumentsToProject()">
                프로젝트에 추가하기
              </v-btn>
              <v-btn v-if="mode=='clip'"
                depressed block dark color="#536bff" @click="addDocumentsToProject()">
                도큐먼트 클립에 추가하기
              </v-btn>
              <v-btn v-if="mode=='refs'"
                depressed block dark color="#536bff" @click="addReferencesToDocument()">
                도큐먼트의 레퍼런스로 추가하기
              </v-btn>
            </div>
            <div class="buttons" v-if="option==2">
              <v-btn depressed block dark
                @click="checkDocument()" 
                :disabled="disabled"
                color="#536bff">{{ $t('add_documents.add')}}
              </v-btn>
            </div>
          </v-card-actions>

          <!-- 2: Compare (input manually) -->
          <v-card-title class="card-title" v-if="option==2&&!done&&doc_preview.compare">
            <span>도큐먼트를 추가하시겠습니까?</span>
            <span>
              <v-btn icon @click="close();gaClick('addDocuments_btn_close')">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </span>
          </v-card-title>

          <v-card-text class="py-5" v-if="option==2&&!done&&doc_preview.compare">
            <v-alert dense outlined color="warning" icon="mdi-alert-circle">
              다른 사용자가 입력한 서지정보와 유사한 도큐먼트가 있습니다. 서지정보를 확인하지 않을 경우 다른 사용자가 입력한 서지정보가 추가됩니다.
            </v-alert>
            <div>
              <span>{{ doc_preview.authors_iso690 }}</span>
              <span>({{ doc_preview.date }})</span>
              <span>{{ doc_preview.title }}</span>
            </div>
          </v-card-text>

          <v-card-actions class="actions" v-if="option==2&&!done&&doc_preview.compare">
            <div class="buttons">
              <v-btn small text @click="addDoc()">기존 도큐먼트 추가하기</v-btn>
              <v-btn small depressed color="#536bff" class="white--text"
                @click="compare(doc_preview.key)">
                도큐먼트 정보 확인하기
              </v-btn>
            </div>
          </v-card-actions>

          <!-- 3: Done (input manually) -->
          <v-card-title class="card-title" v-if="option==2&&done">
            <span v-if="mode=='docs'">
              <span v-if="doc_preview.in">이미 프로젝트에 포함된 도큐먼트입니다.</span>
              <span v-else>{{ $t('add_documents.add_doc_successfully') }}</span>
            </span>
            <span v-if="mode=='clip'">
              <span v-if="doc_preview.in">이미 도큐먼트 클립에 포함된 도큐먼트입니다.</span>
              <span v-else>{{ $t('add_documents.add_doc_successfully') }}</span>
            </span>
            <span v-if="mode=='refs'">
              <span v-if="doc_preview.in">이미 레퍼런스로 추가된 도큐먼트입니다.</span>
              <span v-else>{{ $t('add_documents.add_ref_successfully') }}</span>
            </span>
            <span>
              <v-btn icon @click="close();gaClick('addDocuments_btn_close')">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </span>
          </v-card-title>

          <v-card-text class="py-5" v-if="option==2&&done">
            <v-alert v-if="compare_success" dense outlined type="success" 
              color="success" icon="mdi-check-circle">
              도큐먼트가 성공적으로 개선되었습니다.
            </v-alert>
            <div>
              <span>{{ doc_preview.authors_iso690 }}</span>
              <span>({{ doc_preview.date }})</span>
              <span>{{ doc_preview.title }}</span>
            </div>
          </v-card-text>

          <v-card-actions class="actions" v-if="option==2&&done">
            <div class="buttons">
              <v-btn small text v-if="mode=='docs' || mode=='refs'"
                @click="close();selectDocument(doc_key);gaClick('addDocuments_btn_seeDocument')">
                {{ $t('add_documents.see_document')}}
              </v-btn>
              <v-btn small text v-else
                @click="close();$router.push({name: 'document-clip'});gaClick('addDocuments_btn_seeDocument')">
                <span v-if="$route.name=='document-clip'">닫기</span>
                <span v-else>도큐먼트 클립으로 이동하기</span>
              </v-btn>
              <v-btn small depressed color="#536bff" class="white--text"
                @click="changeDocType(doc_type);gaClick('addDocuments_btn_addOthers')">
                {{ $t('add_documents.add_others')}}
              </v-btn>
            </div>
          </v-card-actions>

        </v-card>

        <!-- Compare -->
        <improve-doc-info v-else
          :opened.sync="compare_opened"
          :compares.sync="compares"
          :result.sync="compare_result">
        </improve-doc-info>
      </template>

    </v-dialog>

    <!-- Confirm dialog -->
    <template>
      <v-dialog v-model="confirm_dialog"
        width="400px">
        <v-card>
          <v-card-title>{{ $t('add_documents.fill')}}</v-card-title>
          <v-card-text>
            <div>{{ $t('add_documents.fill_required')}}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text color="#536bff" @click="confirm_dialog=false">
              {{ $t('add_documents.confirm')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </v-layout>
</template>

<script>
import VClamp from 'vue-clamp'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { doc_types, people_types } from '../../../custom/model'
import { returnDocObj, returnDocMain, returnDocDetail, addIso690, checkInputForm,
  returnDocInput, deleteEmptyFields, createDocsArray } from '../../../custom/function'

export default {

  components: {
    VClamp,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      doc_type_model: doc_types,
      people_type_model: people_types,
      options: ['search', 'upload', 'manual'],
      form_key: 0,

      option: 0,
      compare_opened: false,
      is_expanded: false,

      disabled: false,
      confirm_dialog: false,
      done: false,
      error: false,
      error_message: "",

      doc_type_list: [],
      doc_type: 0,

      document: {},
      keys: [],
      main_keys: [],
      required_keys: [],

      sug_document: {},
      query: {},

      docs_array: [],
      check_result: {},

      doc_preview: {},

      compares: [],
      compare_result: null,
      compare_success: false,

      text: "",

      busy: false,
      searching: false,
      error_search: false,
      query_title: "",
      query_authors: "",
      search_results: [],
      checked_docs: [],

      title: "",
      proj_title: "",
    }
  },

  computed: {
    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },

    ...mapGetters({
      project_info: 'project/project_info',
      documents_in_proj: 'project/documents',
      referred_docs: 'document/referred_docs',
      raw_document: 'document/document',
    }),

    mode() {
      if (this.$route.name == 'project' && !this.$route.query.doc) {
        return 'docs'
      } else if (this.$route.name == 'document' || !!this.$route.query.doc) {
        return 'refs'
      } else {
        return 'clip'
      }
    },

    proj_id() {
      return this.$route.params.id
    },

    doc_key() {
      return this.$route.query.doc
    },

    confirm() {
      return this.required_keys.every(v => 
        Object.keys(this.deleteEmptyFields(JSON.parse(JSON.stringify(this.document)))).includes(v))
    },
  },

  watch: {
    dialog_status(val) {
      if (val) {
        this.changeDocType(this.doc_type)
      }
    },

    option(val) {
      this.resetError()
    },

    doc_type(val) {
      if (val) {
        this.is_expanded = false
      }
    },

    raw_document: {
      handler(val) {
        if (!!val) {
          this.title = this.returnDocDetail(val, val.doc_type).title
        }
      },
      deep: true,
    },

    document: {
      handler(val) {
        if (!!val) {
          let input_doc = this.returnDocInput(parseInt(this.doc_type))
          this.query = {
            year: val[input_doc.year],
            authors: val[input_doc.authors],
          }
          this.resetError()
        }
      },
      immediate: true,
      deep: true,
    },

    text(val) {
      this.resetError()
    },

    sug_document: {
      handler(val) {
        let vm = this
        try {
          this.doc_type = val.doc_type
          this.$store.commit('input/setManualDocType', parseInt(this.doc_type))
          this.document = this.returnDocObj(parseInt(this.doc_type))
          this.keys = Object.keys(this.document)
          this.main_keys = this.returnDocMain(parseInt(this.doc_type)) ?
            this.returnDocMain(parseInt(this.doc_type)) : Object.keys(this.document)
          this.required_keys = this.doc_type_model[parseInt(this.doc_type)]['required_fields']
        } finally {
          Object.keys(val).forEach(v => {
            if (vm.keys.includes(v)) {
              vm.document[v] = val[v]
            }
          })
          this.form_key += 1
        }
      },
      deep: true,
    },

    compare_result(val) {
      if (!!val) {
        this.$set(this.doc_preview, 'compare', false)
        this.done = true
        this.compare_success = true
      }
    },
  },

  created() {
    let vm = this
    try {
      let list = Object.values(this.doc_type_model)
      list.forEach(v => v.name = vm.$t('doc_types.'+v.keyname))
      list.sort((a, b) => (a.order > b.order) ? 1 : -1)
      this.doc_type_list = list
    } finally {
      this.changeDocType(this.doc_type)
    }
  },

  methods: {
    returnDocObj,
    returnDocMain,
    returnDocDetail,
    addIso690,
    checkInputForm,
    returnDocInput,
    deleteEmptyFields,
    createDocsArray,

    ...mapMutations({
      showImportFiles: 'modal/showImportFiles',
    }),

    setColor(doc_type) {
      let color = this.doc_type_model[doc_type].color
      return 'background-color:'+ color
    },

    close() {
      this.$emit('close')
      this.text = ""
      this.checked_docs = []
      this.query_title = ""
      this.query_authors = ""
      this.searching = false
      this.error_search = false
    },

    resetError() {
      if (this.error) {
        this.error = false
      }
    },

    changeDocType(doc_type) {
      this.doc_type = doc_type
      this.initiateForm()
      this.$store.commit('input/setManualDocType', parseInt(doc_type))
      this.form_key += 1
    },

    initiateForm() {
      let vm = this

      this.compare_opened = false
      this.is_expanded = false

      this.disabled = false
      this.confirm_dialog = false
      this.done = false
      this.error = false
      this.error_message = ""
      
      this.docs_array = []
      this.check_result = {}
      this.doc_preview = {}
      this.compares = []
      this.compare_result = null
      this.compare_success = false

      this.document = this.returnDocObj(parseInt(this.doc_type))
      this.keys = Object.keys(this.document)
      this.main_keys = this.returnDocMain(parseInt(this.doc_type)) ?
        this.returnDocMain(parseInt(this.doc_type)) : Object.keys(this.document)
      this.required_keys = this.doc_type_model[parseInt(this.doc_type)]['required_fields']
      
      this.$store.commit('input/throwErrorImportFiles', null)
    },

    getComplete(key) {
      return this.people_type_model[key] ? this.people_type_model[key].complete : null
    },

    pasteText() {
      try {
        this.initiate()
      } finally {
        this.gaClick('addDocuments_btn_paste')
        let result = this.checkInputForm(this.text)
        if (!!result) {
          this.$store.commit('input/setInputFormat', result)
          this.$store.commit('input/setInputText', this.text)
          this.showImportFiles()
          this.close()
        } else {
          this.error = true
          this.error_message = '지원되지 않는 형식입니다. 다시 확인해주세요.'
        }
      }
    },

    initiate() {
      if (!!this.$refs.file) {
        this.$refs.file.value= ''
      }
      this.$store.commit('input/setInputFormat', null)
      this.$store.commit('input/setInputText', '')
      this.$store.commit('input/uploadFiles', [])
      this.gaClick('addDocuments_btn_upload')
    },

    async search() {
      let vm = this
      this.busy = true
      this.checked_docs = []
      this.error_search = false

      if (!!this.query_title||!!this.query_authors) {
        let query_obj = {}
        query_obj.num_records = 300
        if (!!this.query_title) {
          query_obj.title = this.reviseTitle(this.query_title)
        }
        if (!!this.query_authors) {
          query_obj.authors = this.reviseAuthors(this.query_authors)
        }
        try {
          this.search_results = []
          await this.$store.dispatch('search/searchDocuments', query_obj)
        } finally {
          let results = this.$store.getters['search/search_results']
          if (results.length>300) {
            this.error_search = true
          } else {
            results.forEach(doc => {
              vm.search_results.push(vm.returnDocDetail(doc, doc.doc_type))
            })
            if (this.mode == 'docs' || this.mode == 'clip') {
              vm.search_results.forEach(doc => {
                doc['in'] = vm.documents_in_proj.map(v=>v.key).includes(doc.key) ? true : false
              })
            }
            else if (this.mode == 'refs') {
              let in_docs = (JSON.parse(JSON.stringify(vm.referred_docs))).map(v => v.key)
              in_docs.push(this.doc_key)
              vm.search_results.forEach(doc => {
                doc['in'] = in_docs.includes(doc.key) ? true : false
              })
            }
          }
          this.searching = true
          this.busy = false
        }
      } else {
        this.search_results = []
      }
    },

    reviseTitle(title) {
      var title_array = []
      var special_pattern = /[\"\';:\-]/gi

      title_array = title.replace(special_pattern, ' ')
        .split(' ')
        .filter(v => v.trim()!="")
        .map(v => v.trim())
        
      return title_array
    },

    reviseAuthors(authors) {
      let author_array = authors.split(',')
        .map(v => v.split(' ').filter(v => v.trim()!="").map(v => v.trim()))
      return author_array
    },

    getURL(db) {
      if (db == 'g') {
        return 'https://scholar.google.com/scholar?q=' 
          + this.query_title.split(" ").join("+") + "+"
          + this.query_authors.split(/[ ,]+/).join("+")
      } else if (db == 's') {
        return 'https://www.semanticscholar.org/search?q='
          + this.query_title.split(" ").join("%20") + "%20"
          + this.query_authors.split(/[ ,]+/).join("%20")
      } else if (db == 'm') {
        return 'https://academic.microsoft.com/search?q='
          + this.query_title.split(" ").join("%20") + "%20"
          + this.query_authors.split(/[ ,]+/).join("%20")
      }
    },

    checkDoc(key) {
      if (this.checked_docs.includes(key)) {
        let remove_index = this.checked_docs.indexOf(key)
        if (remove_index !== -1) {
          this.checked_docs.splice(remove_index, 1)
        }
      } else {
        this.checked_docs.push(key)
      }
    },

    async addDocumentsToProject() {
      try {
        let id = this.mode=='clip' ? 
          this.$store.getters['project/projects'].filter(v => v.mode == 9)[0].proj_id : this.proj_id
          await this.$store.dispatch('project/addDocumentsToProject', {
            proj_id: id,
            documents: this.checked_docs
          })
      } finally {
        this.close()
      }
    },

    async addReferencesToDocument() {
      try {
        await this.$store.dispatch('input/addReferences', {
          doc_key: this.$route.query.doc,
          documents: this.checked_docs,
          proj_id: this.proj_id,
        })
      } finally {
        this.close()
      }
    },

    uploadFieldChange(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
      } else {
        this.$store.commit('input/setInputFormat', 'files')
        this.$store.commit('input/uploadFiles', files)
        this.showImportFiles()
        this.close()
      }
    },

    async checkDocument() {
      if (this.disabled) return
      this.disabled = true

      if (this.confirm) {
        this.docs_array = this.createDocsArray([this.document])
        try {
          await this.$store.dispatch('input/checkDocuments', {
            docs_array: this.docs_array,
            insert_new: true,
          })
        } catch(e) {
          this.error = true
          let error_code = !!e.response ? e.response.status : '000'
          this.error_message = this.$t('add_documents.error_checking') + "(" + error_code + ")"
        } finally {
          if (!this.error) {
            this.check_result = this.$store.getters['input/check_result']
            this.gaClick('addDocuments_btn_inputDocument')
            this.getDocPreview()
          }
        }
      } else {
        this.confirm_dialog = true
      }

      setTimeout(() => {
        this.disabled = false
      }, 500)
    },

    getDocPreview() {
      let doc = {}
      let result = this.check_result[0].result
      let key = this.check_result[0].data[0].doc_key
      try {
        doc = JSON.parse(JSON.stringify(this.docs_array[0].document))
        doc = this.returnDocDetail(doc, doc.doc_type)
        doc['key'] = key
        this.addIso690([doc]).then(res => doc = res[0])
        this.$set(doc, 'compare', result == 'compare' ? true : false)
        if (this.mode=='docs') {
          doc['in'] = this.documents_in_proj.map(v=>v.key).includes(key) ? true : false
        } 
        else if (this.mode=='refs') {
          doc['in'] = this.referred_docs.map(v=>v.key).includes(key) ? true : false
        }
      } finally {
        this.doc_preview = doc
        if (result != 'compare') { 
          this.addDoc()
          this.done = true 
        }
      }
    },

    async addDoc() {
      if (this.mode == 'docs') {
        this.addDocument(this.$route.params.id)
      } else if (this.mode == 'refs') {
        this.addReference()
      } else {
        try {
          await this.$store.dispatch('project/getProjects')
        } // TODO: exception
        finally {
          let clip_id = this.$store.getters['project/projects'].filter(v => v.mode == 9)[0].proj_id
          this.addDocument(clip_id)
        }
      }
    },

    async addDocument(proj_id) {
      let key = this.doc_preview.key
      if (this.doc_preview.in) {
        this.done = true
      } 
      else {
        this.gaClick('addDocuments_btn_addDocument')
        try {
          await this.$store.dispatch('project/addDocumentsToProject', {
            proj_id,
            documents: [key]
          })
        } // TODO: exception
        finally {
          // if (this.mode == 'docs') {
          //   await this.$store.dispatch('project/getProject', {proj_id})
          // }
          this.done = true
        }
      }
    },

    async addReference() {
      let error = false
      let key = this.doc_preview.key
      if (this.doc_preview.in) {
        this.done = true
      } else {
        try {
          await this.$store.dispatch('input/addReferences', {
            doc_key: this.$route.query.doc,
            documents: [key],
            proj_id: this.proj_id,
          })
        } catch(e) {
          this.$store.commit('error/setDialog', true)
          this.$store.commit('error/setErrorCode', !!e.response ? e.response.status : '000')
        } finally {
          this.done = true
          this.gaClick('addDocuments_btn_addReference')
        }
      }
    },

    compare(key) {
      let compare_keys = this.check_result[0].data.map(v=>v.doc_key)
      this.compares = [{
        compare_keys: compare_keys,
        key: key,
        user_doc: this.docs_array[0]
      }]
      this.compare_opened = true
    },

    selectDocument(key) {
      let to = { name: 'project', query: { doc: this.doc_preview.key } }
      this.$router.push(to)
    },

    gaClick(param) {
      this.$analytics.logEvent('click', { name: param })
    },

  },
}
</script>

<style scoped>

  .card-title {
    font-size: 1.25rem;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    background-color: #fafafb !important;
  }

  .card-title-ref {
    color: #455ffe !important;
    background-color: rgba(83, 107, 255, 0.1) !important;
  }

  .card-title-content {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }

  .card-title-left {
    display: flex;
    align-items: center;
  }

  .card-title-left > span {
    margin-right: 5px;
  }
  
  button input[type=file] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center; 
    opacity: 0;
  }

  .expand {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
  }

  .actions {
    display: flex;
    flex-direction: column;
  }

  .buttons {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-end;
    align-items: flex-start;
  }

  /* .btn-magnify {
    display: flex;
    align-items: flex-end;
  } */

  .input-field {
    display: grid;
    grid-template-columns: 120px auto;
  }

  .input-label {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    padding-right: 22px;
    /* padding-top: 10px; */
    text-align: end;
  }

  .required {
    color: #F65058;
    padding-left: 3px;
  }

  .point-element {
    cursor: pointer;
  }

  .meta-title {
    font-size: 16px;
    font-weight: 700;
  }

  .meta-title, .meta-text {
    margin-bottom: 10px;
  }

  .compare-card-wrapper {
    margin-top: 12px;
  }

  .compare-card {
    display: flex;
    flex-direction: row;
  }

  .compare-card-icon {
    margin-right: 10px;
  }

  .compare-card-text {
    font-size: 0.7rem;
  }

  .compare-card-text-title {
    font-size: 1rem;
    font-weight: 500;
    color: #2c3e50;
  }

  .divider {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 20px 0;
    color: gray;
  }

  /* Doc-card */

  .doc-card-content {
    padding: 15px 0 5px;
  }

  .card-header, .header-title {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .header-title {
    margin-left: 8px;
  }

  .search-results-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
  }

  .doctype-dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
  }

  .card-meta {
    margin: 6px 0 0 15px;
    color: #858d97;
  }

  .card-detail {
    margin: 4px 0 0 15px;
    color: rgb(97, 85, 80);
    font-style: italic;
  }

  /* Empty */

  .empty-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
  }

  .empty-contents-title {
    font-size: 20px;
    padding-bottom: 20px;
  }

  .empty-contents-meta {
    font-size: 14px;
    padding-bottom: 20px;
    color: rgb(0, 0, 0, .4);
  }

  .empty-contents-button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  #loading {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  .text-field {
    margin-right: 8px;
  }

  #exp-wrapper {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
  }

  #exp-title {
    display: flex;
    justify-content: center;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  #exp-meta {
    margin-top: 20px;
  }

  .explanation {
    color: #FF5193;
  }

</style>



// WEBPACK FOOTER //
// src/components/modal/input/AddDocuments.vue